var link_preview_default = {
  "fontElementMap": "TDPCV",
  "linkPreviewContainer": "eLuIX",
  "linkPreview": "_6fNYM",
  "linkPreviewImage": "sxE9w",
  "linkPreviewInfo": "UoEPp",
  "linkPreviewTitle": "_9wO-f",
  "linkPreviewDescription": "HIWo4",
  "linkPreviewUrl": "qPF1t"
};
export {
  link_preview_default as default
};
//# sourceMappingURL=link-preview-scss.js.map
